import styled from 'styled-components';
import { useParams, useNavigate } from 'react-router-dom';
import palette from 'lib/styles/palette';
import { useState } from 'react';
import Modal from 'components/common/Modal';
import MasterKidsCreator from '../MasterKidsCreator';
import AskModal from 'components/common/AskModal';
import { BackArrow } from 'lib/styles/icons';
import useContractViewer from 'hooks/contract/useContractViewer';
import Loading from 'components/common/Loading';
import ErrorNoti from 'components/common/ErrorNoti';
import autoHyphen from 'utils/autoHyphen';
import ContractViewerMasterKidItem from './ContractViewerMasterKidItem';
import ContractViewerPlaceCard from './ContractViewerPlaceCard';
import NotiModal from 'components/common/NotiModal';

const ContractViewer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [showAskModal, setShowAskModal] = useState(false);

  const {
    isLoading,
    error,
    contract,
    master,
    masterKids,
    deleteContractMutation,
    onEdit,
    onDelete,
  } = useContractViewer(id);
  const tel = autoHyphen(contract?.tel);

  if (isLoading || deleteContractMutation.isLoading) return <Loading />;
  if (error?.response.status === 500) return <ErrorNoti />;

  return (
    <>
      {deleteContractMutation.error?.response.status === 500 && (
        <NotiModal
          closeModal={() => deleteContractMutation.reset()}
          msg="서버 오류로 삭제에 실패했습니다"
          fontL
        />
      )}
      {showModal && (
        <Modal closeModal={() => setShowModal(false)}>
          <MasterKidsCreator
            closeModal={() => setShowModal(false)}
            masterId={master?.id}
          />
        </Modal>
      )}
      {showAskModal && (
        <AskModal
          closeModal={() => setShowAskModal(false)}
          action="삭제"
          message="정말로 삭제하시겠습니까?"
          actionFc={() => {
            setShowAskModal(false);
            onDelete();
          }}
        />
      )}
      <ContractViewerBlock>
        <BackArrow className="back-icon" onClick={() => navigate(-1)} />
        <div className="title">{contract?.company}</div>
        <div className="index">1. 계약 정보</div>
        <div className="row">
          <div>SI코드</div>
          <div>{contract?.code}</div>
        </div>
        <div className="row">
          <div>계약 기간</div>
          <div>{`${contract?.termStartDate} ~ ${contract?.termEndDate}`}</div>
        </div>
        <div className="row">
          <div>계약자</div>
          <div>{contract?.name}</div>
        </div>
        <div className="row">
          <div>연락처</div>
          <div>{tel}</div>
        </div>
        <div className="row">
          <div>계약 내용</div>
          <div
            style={{ width: 300, display: 'flex', justifyContent: 'flex-end' }}
          >
            {contract?.detail ? contract?.detail : '입력 사항이 없습니다'}
          </div>
        </div>
        <div className="row" style={{ marginTop: 25 }}>
          <div>설치 장소</div>
          <div className="place-wrapper">
            {contract?.store.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  fontSize: 16,
                }}
              >
                설치 장소가 없습니다
              </div>
            ) : (
              contract?.store.map(store => (
                <ContractViewerPlaceCard
                  key={store.id}
                  store={store}
                  storeLength={contract.store.length}
                />
              ))
            )}
          </div>
        </div>
        <div className="divider" />
        <div className="index">2. Master ID 정보</div>
        <div className="row">
          <div>Master ID</div>
          <div>{master?.userId}</div>
        </div>
        <div className="row">
          <div>사용자 이름</div>
          <div>{master?.name}</div>
        </div>
        <div className="row">
          <div>부서</div>
          <div>{master?.team}</div>
        </div>
        <div className="row">
          <div>직급</div>
          <div>{master?.position}</div>
        </div>
        <div className="row">
          <div>연락처</div>
          <div>{autoHyphen(master?.tel)}</div>
        </div>
        <div className="row">
          <div>이메일</div>
          <div>{master?.email}</div>
        </div>
        <div className="divider" />
        <div className="index">3. Master Kids ID 정보</div>
        {masterKids?.length === 0 ? (
          <div style={{ marginTop: 30, textAlign: 'center', fontWeight: 500 }}>
            등록된 Master Kid가 없습니다
          </div>
        ) : (
          <>
            <div className="row" style={{ fontWeight: 'bold' }}>
              ID
            </div>
            {masterKids?.map(masterKid => (
              <ContractViewerMasterKidItem
                key={masterKid.id}
                masterKid={masterKid}
              />
            ))}
          </>
        )}
        <div className="divider" />
        <ButtonBlock>
          <StyledButton onClick={() => setShowAskModal(true)}>
            삭제
          </StyledButton>
          <StyledButton onClick={onEdit}>수정</StyledButton>
          <StyledButton blue onClick={() => setShowModal(true)}>
            Master Kids ID 생성
          </StyledButton>
        </ButtonBlock>
      </ContractViewerBlock>
    </>
  );
};

export default ContractViewer;

const ContractViewerBlock = styled.div`
  width: 480px;
  margin: 0 auto;
  margin-top: 25px;
  padding: 0 15px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
  position: relative;

  .back-icon {
    position: absolute;
    top: 30px;
    font-size: 1.3rem;
    margin-left: 5px;
    cursor: pointer;
  }

  .title {
    margin-top: 30px;
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  .index {
    margin-top: 30px;
    font-size: 1.1rem;
    font-weight: 500;
  }

  .row {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .place-wrapper {
    width: 300px;
    max-height: 400px;
    padding-right: 4px;
    font-size: 14px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
      background: ${palette.theme[0]};
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${palette.theme[3]};
      border-radius: 10px;
    }
  }

  .place-box:last-child {
    margin-bottom: 0;
  }

  .place-icon {
    font-size: 20px;
  }

  .place-title {
    margin-bottom: 6px;
    font-weight: 500;
  }

  .divider {
    margin-top: 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

const ButtonBlock = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
`;

const StyledButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background: ${props => (props.blue ? palette.theme[3] : palette.theme[0])};
  color: #fff;
  cursor: pointer;
  :hover {
    background: ${palette.theme[2]};
  }
  & + & {
    margin-left: 10px;
  }
`;
